var viewer_rtlignore_default = {
  "gallery_container": "_0mkWG",
  "imageTitleContainer": "yJC4D",
  "clickableItem": "rgsQ-",
  "prerender": "Cq-Qx",
  "expandContainer": "EZSBQ",
  "expandIcon": "M8Ja5",
  "itemOverlay": "w4yVZ",
  "imageTitle": "s-RwO",
  "pointer": "ZkhUx",
  "fadeIn": "PCdNj",
  "changing_background": "xeV2h"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
